<script>
import { put, get } from '@rails/request.js'

export default {
  props: {
    event: Object
  },
  methods: {
    editRequirement: async function() {
      const response = await get(this.event.extendedProps.requirementEditUrl)
      if (!response.ok) {
        return
      }

      const content = await response.text
      $("#app-modal-sm .modal-content").html(content)

      bootstrap.Modal.getOrCreateInstance("#app-modal-sm").show()
    }
  }
}
</script>
<template>
  <div style="min-height: 0.5rem;">
    <span class="user-select-none translate-middle-y position-absolute start-0 pb-1">
      <span class="badge" style="margin-bottom: 1px;" :class="this.event.extendedProps.pillClassNames" @click="this.editRequirement">
        <span class="bi bi-person-fill"></span>
        {{ event.extendedProps.parallelShiftsCount }}
        
        <template v-if="event.extendedProps.hardLimit > 0">
          <span class="bi bi-circle-fill ms-1 text-warning"></span>
          {{event.extendedProps.hardLimit}}
        </template>
        
        <template v-if="event.extendedProps.softLimit > 0">
          <span class="bi bi-circle-fill ms-1 text-success"></span>
          {{event.extendedProps.softLimit}}
        </template>

        <span v-if="event.extendedProps.comment" class="bi bi-chat-left-dots ms-1"></span>
      </span>
    </span>
  </div>
</template>
